module.exports = __webpack_public_path__ + "img/cloudforest.2d02dd1.webp";